import useAppContext from 'flow/hooks/useAppContext';

const QuotaExceededNotice = () => {
    const { i18next } = useAppContext();

    return (
        <p className="px-2 text-sm text-red-600">
            {i18next.t('settings.transcriptions.quota.exceeded')}
        </p>
    );
};

export default QuotaExceededNotice;
